// src/components/DashboardFullscreen.jsx
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import supabase from "../lib/supabase";

export default function DashboardFullscreen({ session }) {
  const navigate = useNavigate();
  const location = useLocation();
  const metabaseUrl = location.state?.metabaseUrl;

  const iframeRef = useRef(null);
  const [refreshing, setRefreshing] = useState(false);
  const [containerWidth, setContainerWidth] = useState(null);

  useEffect(() => {
    const el = document.querySelector('.dashboard-iframe-wrapper');
    if (el) {
      setContainerWidth(el.offsetWidth);
    }
  }, []);
  const handleLogout = async () => {
    try {
      await supabase.auth.signOut({ scope: "local" });
      localStorage.clear();
      sessionStorage.clear();
      window.location.assign("/login");
    } catch (err) {
      console.error("Logout failed:", err);
      window.location.assign("/login");
    }
  };

  const handleBack = () => {
    navigate("/dashboard");
  };

  // Manual refresh
  const refreshIframe = () => {
    if (!iframeRef.current) return;
    setRefreshing(true);

    // Force reload by resetting src
    iframeRef.current.src = metabaseUrl;

    setTimeout(() => setRefreshing(false), 800);
  };

  // Auto-refresh every 1 hour
  useEffect(() => {
    const interval = setInterval(() => {
      refreshIframe();
    }, 60 * 60 * 1000); // 1 hour

    return () => clearInterval(interval);
  }, [metabaseUrl]);

  // Refresh when user returns to tab
  // useEffect(() => {
  //   const onFocus = () => refreshIframe();
  //   window.addEventListener("focus", onFocus);
  //   return () => window.removeEventListener("focus", onFocus);
  // }, [metabaseUrl]);

  if (!metabaseUrl) return <div>Error: No dashboard URL provided.</div>;

  return (
      <div className="dashboard-fullscreen">
        <button className="back-button" onClick={handleLogout}>⏻ Logout</button>
        <button className="back-button" onClick={handleBack}>← Back to Dashboard Catalogue</button>
        <button className="back-button" onClick={refreshIframe} disabled={refreshing}>
          {refreshing ? "⟳ Refreshing…" : "⟳ Refresh Dashboard"}
        </button>

        <div className="dashboard-iframe-wrapper">
          <iframe
            ref={iframeRef}
            src={metabaseUrl}
            title="Metabase Dashboard"
            className="dashboard-iframe"
            allowtransparency="true"
          />
        </div>
      </div>
    );
}